import Vue from 'vue';
import Vuex from 'vuex';
import { SellerService, ContentService, LeadService } from '@/services';
import { ACTION_NAMES } from '@/constants';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    contents: {},
    leadInfo: {},
    rooftopInfo: {},
    showAppLoader: false,
  },
  mutations: {
    SAVE_LEAD_INFO(state, data) {
      state.leadInfo = data;
    },
    saveContents(state, data) {
      state.contents = data;
    },
    saveRooftop(state, data) {
      state.rooftopInfo = data;
    },
    setShowAppLoader(state, data) {
      state.showAppLoader = data;
    },
  },
  actions: {
    async loadAppContent({ dispatch, commit }, payload) {
      commit('setShowAppLoader', true);

      const { lead, engagementAction } = payload;

      await dispatch('loadLeadInfo', lead);
      dispatch('loadContents', engagementAction);
    },
    async loadLeadInfo({ commit, dispatch }, lead) {
      try {
        const result = await LeadService.getLead(lead.receiverId, lead.id);
        commit('SAVE_LEAD_INFO', result.data);

        const rooftopId = result.data.companies_id;
        dispatch('loadRooftop', rooftopId || process.env.VUE_APP_DEV_ROOFTOP_ID);
      } catch (error) {
        throw new Error(`API ${error}`);
      }
    },
    async loadContents({ commit }, engagementAction) {
      try {
        const response = await ContentService.getContentByAction(engagementAction);
        const { data } = response.data || {};

        if (engagementAction === ACTION_NAMES.TRADE_WALK) {
          const [content] = data;
          commit('saveContents', content);
        } else {
          commit('saveContents', data);
        }
      } catch (error) {
        throw new Error(`API ${error}`);
      } finally {
        commit('setShowAppLoader', false);
      }
    },
    async loadRooftop({ commit }, rooftopId) {
      try {
        const result = await SellerService.getRooftopById(rooftopId);
        commit('saveRooftop', result.data);
      } catch (error) {
        throw new Error(`API ${error}`);
      }
    },
  },
  modules: {},
});
